import * as React from "react"
import { Box, Flex, Stack, chakra } from "@chakra-ui/react"
import Logo from "./Logo"

const footerLinks = [
  { label: "Products", href: "/#products" },
  { label: "Pricing", href: "/pricing" },
  { label: "About", href: "/about" },
  { label: "PM resource center", href: "/resources" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
]

const Footer: React.FC = () => {
  return (
    <Box
      as="footer"
      px={{ base: 6, md: 12 }}
      py="40px"
      borderTop="1px solid"
      borderColor="#e2e6f2"
      fontSize="0.78rem"
      color="#5a6380"
      bg="#fafbfe"
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="space-between"
        gap={{ base: 4, md: 0 }}
        textAlign={{ base: "center", md: "left" }}
      >
        <Logo size="md" />

        <Stack
          direction={{ base: "column", md: "row" }}
          gap={{ base: 2, md: "24px" }}
          align="center"
        >
          {footerLinks.map((link) => (
            <chakra.a
              key={link.label}
              href={link.href}
              color="inherit"
              textDecoration="none"
              _hover={{ color: "#0f1629" }}
            >
              {link.label}
            </chakra.a>
          ))}
        </Stack>

        <Box>&copy; 2026 Spot. All rights reserved.</Box>
      </Flex>
    </Box>
  )
}

export default Footer
